
import { Component, Vue } from "vue-property-decorator";
import configForm from "../data-config/components/config-form.vue";
import msgList from "./components/msg-list.vue";
import { objAny } from "@/common/common-interface";
import { getPileData } from "@/api/oms-operation-service";
import tio from "@/common/tiows";
import { topicSubscribe, updToken } from "@/api/api-basic-websocket";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-config-form": configForm,
    "pi-msg-list": msgList
  }
})
export default class CollectionChargingOperation extends Vue {
  private current = -1;

  private tabsActive = "tab1";
  private formInline: objAny = {};
  private gunData: objAny = {};

  private msgList: object[] = [];
  private tiows: objAny = {};
  private pilePkId = "";
  private isOpen = 0; // 0 未初始化  1 连接中  2 连接成功  3 连接失败/关闭
  private timer = 0;
  public clearMsg() {
    this.msgList = [];
  }
  public getContentData(data: objAny, gunData?: objAny) {
    this.formInline = data;
    // this.formInline.pilePkId = "202007140003";
    // this.formInline.gunPkId = "1291540958642114562";
    if (gunData) {
      this.gunData = gunData;
    }
    if (this.formInline.gunPkId == "") {
      this.$Message.error(i18n.t("dataConfig.gunPkIdPl"));
    } else {
      if (this.formInline.gunPkId && this.formInline.gunPkId != "") {
        this.topicSubscribe();
        this.getPileData();
      }
    }
  }
  async topicSubscribe() {
    const ret = await topicSubscribe({
      pilePkId: this.formInline.pilePkId,
      msgCodes: [1030, 1031, 1040, 1060, 1070, 1080, 1090, 1100, 2030, 2040]
    });
    if (ret.status == this["$config"].apiStatus) {
      console.log("订阅成功");
    }
  }

  async getPileData() {
    if (this.formInline.pilePkId && this.formInline.pilePkId != "") {
      const ret = await getPileData({ sn: this.formInline.pilePkId });
      if (ret.status == this["$config"].apiStatus) {
        const data = ret.data;
        data.map((item: objAny) => {
          if (item.gunPkId == this.formInline.gunPkId) {
            this.gunData = item;
          }
        });
        if (this.gunData.gunStatus == 7) {
          this.current = 0;
        } else if (this.gunData.gunStatus == 1) {
          this.current = 1;
        } else if (this.gunData.gunStatus == 0) {
          this.current = 3;
        } else if (this.gunData.gunStatus == 8) {
          this.current = 4;
        }
      }
    }
  }

  public init() {
    this.isOpen = 1;
    this.pilePkId = this.formInline.pilePkId;
    this.tiows = new tio.ws({
      onopen: this.onopen,
      onmessage: this.onmessage,
      onclose: this.onclose,
      ping: this.ping,
      onerror: this.onerror
    });
    this.tiows.connect(true);
  }

  public onopen() {
    console.log("连接成功");
    this.isOpen = 2;
  }
  public onmessage(event: objAny) {
    const data = event.data;
    const msgBody = eval("(" + data + ")");
    console.log(msgBody);
    if (msgBody && msgBody.data) {
      this.msgList.push(msgBody);
    }
  }
  public onclose() {
    console.log("onclose");
    this.isOpen = 3;
  }
  public ping() {
    // console.log(ws);
  }
  public onerror(ws: objAny, event: objAny) {
    console.log(ws);
    const data = event.data;
    console.log(data);
    // const msgBody = eval("(" + data + ")");
    // console.log(msgBody);
  }
  async updToken() {
    const ret = await updToken();
    if (ret.status == this["$config"].apiStatus) {
      console.log("刷新token成功");
    } else {
      console.log("刷新token失败");
    }
  }
  mounted() {
    this.init();
  }
  created() {
    this.timer = setInterval(this.updToken, 300000);
  }
  beforeDestroy() {
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
  }
}
